import Header from './components/Header';
import Hero from './components/Hero';
import SectionUpdates from './components/SectionUpdates';
import SectionMedia from './components/SectionMedia';
import SectionTopics from './components/SectionTopics';
import SectionContact from './components/SectionContact';
import SectionFeatures from './components/SectionFeatures';
import SectionCards from './components/SectionCards';
import SectionApp from './components/SectionApp';
import SectionAbout from './components/SectionAbout';
import SectionCarousel from './components/SectionCarousel';
import SectionIndex from './components/SectionIndex';
import SectionFaq from './components/SectionFaq';
import SectionComments from './components/SectionComments';
import SectionRanking from './components/SectionRanking';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <SectionUpdates />
        <SectionMedia />
        <SectionTopics />
        <SectionContact />
        <SectionFeatures />
        <SectionCards />
        <SectionApp />
        <SectionAbout />
        <SectionCarousel />
        <SectionIndex />
        <SectionFaq />
        <SectionComments />
        <SectionRanking />
      </main>
      <Footer />
    </>
  );
}